import clsx from 'clsx';
import { ComponentType } from 'react';
import { InputHTMLAttributes } from 'react';
import React from 'react';
import styles from './Checkbox.module.scss';

export interface Props
    extends Omit<InputHTMLAttributes<HTMLInputElement>, 'label' | 'className'> {
    label?: string;
    className?: string;
    Component?: ComponentType<InputHTMLAttributes<HTMLInputElement>>;
}

export const Checkbox: React.FC<Props> = ({
    label,
    className,
    Component = 'input',
    children,
    ...props
}) => {
    const { disabled } = props;
    return (
        <label
            className={clsx(
                styles.checkbox,
                disabled && styles.disabled,
                className
            )}
        >
            <Component
                className={styles.input}
                type="checkbox"
                disabled={disabled}
                {...props}
            />
            <span className={clsx(styles.mark, disabled && styles.disabled)}>
                <img
                    src="/assets/purchases-filter/checkbox.svg"
                    className={styles.empty}
                    alt="checkbox"
                />
                <img
                    src="/assets/purchases-filter/checkbox_checked.svg"
                    className={styles.checked}
                    alt="checkbox"
                />
            </span>
            <span className={clsx(styles.label, disabled && styles.disabled)}>
                {label || children}
            </span>
        </label>
    );
};

export default Checkbox;
